import { DonationFormCategory, TicketingFormCategory } from "@simplyk/common";

import { LiveEditorStepKey } from "../LiveEditorStep.enum";

import { StepSidebarItems } from "@/components/LiveEditorElements/StepTypes";
import { getFormCategoryInfo } from "@/features/LiveFormEditor/common/formCategory.helper";
import { DashboardTranslationKey } from "@/public/@types/translations";

export type FormStepSidebarItems = StepSidebarItems<LiveEditorStepKey>;

interface GetFormStepSidebarItemsParams {
  formCategory: TicketingFormCategory | DonationFormCategory;
  hasAutomatedEmails?: boolean;
}

export const getFormStepSidebarItems = ({
  formCategory,
  hasAutomatedEmails,
}: GetFormStepSidebarItemsParams): FormStepSidebarItems => {
  const { isShop, isMembership, isAuction, isCustom, isSweepstakes } = getFormCategoryInfo(formCategory);

  const getTicketsStepLabel = (): DashboardTranslationKey => {
    if (isSweepstakes) {
      return "sweepstakes.navigation.entries";
    }
    if (isShop || isAuction || isCustom) {
      return "liveFormEditor.navigation.items";
    }
    if (isMembership) {
      return "liveFormEditor.navigation.membershipRates";
    }
    return "liveFormEditor.navigation.tickets";
  };

  const getETicketStepLabel = (): DashboardTranslationKey => {
    if (isSweepstakes) {
      return "sweepstakes.navigation.entryConfirmation";
    }
    if (isMembership) {
      return "liveFormEditor.navigation.membershipCard";
    }
    return "liveFormEditor.navigation.eTicket";
  };

  const getThankYouEmailStepLabel = (): DashboardTranslationKey => {
    if (hasAutomatedEmails) {
      return "liveFormEditor.navigation.automatedEmails";
    }
    return "liveFormEditor.navigation.thankYouEmail";
  };

  return {
    "campaign-life-cycle": "liveFormEditor.navigation.campaignLifeCycle",
    title: "liveFormEditor.navigation.title",
    date: isSweepstakes ? "sweepstakes.navigation.drawDate" : "liveFormEditor.navigation.date",
    location: "liveFormEditor.navigation.address",
    prizes: "liveFormEditor.navigation.prizes",
    description: "liveFormEditor.navigation.description",
    color: "liveFormEditor.navigation.color",
    banner: "liveFormEditor.navigation.banner",
    logo: "liveFormEditor.navigation.logo",
    "order-fulfillment": "liveFormEditor.navigation.orderFulfillment",
    tickets: getTicketsStepLabel(),
    "add-donation": "liveFormEditor.navigation.donation",
    "add-ons": "liveFormEditor.navigation.addOns",
    "discount-codes": "liveFormEditor.navigation.discounts",
    "business-model": "liveFormEditor.navigation.businessModel",
    "e-ticket": getETicketStepLabel(),
    "thank-you-email": getThankYouEmailStepLabel(),
    "thank-you-email-not-winner": "liveFormEditor.navigation.thankYouEmailLoser",
    "automated-communications": "liveFormEditor.navigation.automatedCommunications",
    "quickbooks-mapping": "quickbooks.lfe.title",
    "advanced-settings": "liveFormEditor.navigation.advancedSettings",
    review: "liveFormEditor.navigation.review",
    "fundraising-goal": isCustom
      ? "liveFormEditor.navigation.fundraisingTarget"
      : "liveFormEditor.navigation.fundraisingGoal",
    "tax-receipts": "liveFormEditor.navigation.taxReceipts",
    "suggested-donation-amounts": "liveFormEditor.navigation.suggestedDonationAmounts",
    "p2p-settings": "liveFormEditor.navigation.p2pSettings",
    questions: "liveFormEditor.navigation.questions",
  };
};
